import { type TableParamsType } from '../../types/common';
import { type UseQueryResult, useQuery } from 'react-query';

import {
  ReleaseAppSharedService,
  ReleaseService,
  // eslint-disable-next-line camelcase
  PagedResultDto_IncludedReleaseDetailDto,
} from '../../services/wealthlane-award-services';

const useGetReleaseIncludedList = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  tableInfo: TableParamsType,
  filterData: TableParamsType,
  selectedId: string
): UseQueryResult<
  // eslint-disable-next-line camelcase
  | PagedResultDto_IncludedReleaseDetailDto
  | undefined,
  unknown
> => {
  // const {
  //   grantName: grantId,
  //   awardTypeId: awardTypeId,
  //   createdFromDate: fromDate,
  //   createdToDate: toDate,
  //   settlementTypeIds,
  // } = filterData;
  const {
    filter: searchKeyWord,
    sorting,
    skipCount,
    maxResultCount,
    grantName: grantId,
    awardTypeId: awardTypeId,
    createdFromDate: fromDate,
    createdToDate: toDate,
    settlementTypeIds,
    _force,
  } = tableInfo;
  const releaseIncludedList = useQuery(
    [
      'getReleaseIncludedList',
      searchKeyWord,
      sorting,
      skipCount,
      maxResultCount,
      grantId,
      fromDate,
      toDate,
      selectedId,
      awardTypeId,
      settlementTypeIds,
      _force,
    ],
    async () => {
      if (selectedId) {
        return await handleRequest(
          ReleaseAppSharedService.getApiAwardApiAppReleaseIncludedReleaseList(
            selectedId,
            sorting,
            skipCount,
            maxResultCount,
            searchKeyWord,
            grantId,
            awardTypeId,
            fromDate,
            toDate,
            settlementTypeIds
          )
        );
      }
    },
    {
      select: (data) => {
        if (data != null) {
          return data;
        }
      },
    }
  );

  return releaseIncludedList;
};

export default useGetReleaseIncludedList;
